import { CallStateEnum } from '@models/call-state.model.ts';

export const callStateStatusSlice = (set: any, get: any) => ({
  isFolderLoading: () => get().folderCallState === CallStateEnum.Loading,
  isFolderLoaded: () => get().folderCallState === CallStateEnum.Loaded,
  isFolderError: () => get().folderCallState === CallStateEnum.Error,
  isMediaLoading: () => get().mediaCallState === CallStateEnum.Loading,
  isMediaLoaded: () => get().mediaCallState === CallStateEnum.Loaded,
  isMediaError: () => get().mediaCallState === CallStateEnum.Error,
  isMoveTreeLoading: () => get().moveTreeCallState === CallStateEnum.Loading,
  isMoveTreeLoaded: () => get().moveTreeCallState === CallStateEnum.Loaded,
  isMoveTreeError: () => get().moveTreeCallState === CallStateEnum.Error,
  isUploadByUrlLoading: () =>
    get().uploadByUrlCallState === CallStateEnum.Loading,
  isUploadByUrlLoaded: () =>
    get().uploadByUrlCallState === CallStateEnum.Loaded,
  isUploadByUrlError: () => get().uploadByUrlCallState === CallStateEnum.Error
});
